const dashboard = {
  dashboard: {
    title: 'Painel',
    switchToClassic: 'Mudar para o modo de exibição clássico',
    comingSoon: 'Em breve',
    companyScoreCard: 'Scorecard de desempenho da empresa',
    enphaseSince: 'Instalando o Enphase desde',
    sitesCommissioned: 'Unidades ativadas',
    microinverters: 'Microinversores instalados',
    batteriesInstalled: 'Baterias instaladas',
    nps: 'Pontuação do promotor líquido',
    ensembleCertified: 'Empresa de instalação com autorização de armazenamento',
    einLearn: 'Saiba mais sobre EIN',
    yes: 'Sim',
    no: 'Não',
    lastMonth: { one: 'no último 1 mês', other: 'nos últimos %{count} meses' },
    congratulations: 'Parabéns!',
    acceptInvitation: 'Aceitar convite',
    einInvitation: 'Você recebeu um convite para fazer parte da Enphase Installer Network..',
    leadsInvitation: 'Você recebeu um convite para fazer parte do Programa Enphase Leads.',
    announcements: 'Anúncios',
    systems: 'Sistemas',
    all: 'Todos',
    alerts: 'Alertas',
    activations: 'Ativações',
    leads: 'Leads',
    search: 'Procurar',
    noResult: 'Nenhum resultado encontrado',
    viewActivations: 'Ver todas as ativações',
    viewLeads: 'Ver todos os Leads',
    viewSystems: 'Ver todos os sistemas',
    addNewSystems: 'Adicionar Novo Sistema',
    total: 'Total',
    activatedSites: 'Unidades ativadas',
    nameId: 'Nome / Id',
    status: 'Status',
    city: 'Cidade',
    state: 'Estado / Prov',
    leadSource: 'Origem do Lead',
    createNewLead: 'Criar novo Lead',
    notAvailable: 'Não disponível',
    quickAccess: 'Acesso rápido',
    contactUs: 'Contate-Nos',
    ensemble: 'Ensemble',
    serviceShortcuts: 'Atalhos de serviço',
    newsletter: 'Newsletter da Instaladora',
    service: 'Gestor de serviço',
    enphaseleads: 'Programa de Leads da Enphase',
    enphaseCommunity: 'Comunidade Enphase',
    enphaseStore: 'Loja Enphase',
    systemConfigurator: 'Configurador de sistemas',
    criticalUpdates: 'Atualizações críticas',
    documentation: 'Documentação',
    brandLibrary: 'Biblioteca da marca',
    training: 'Formação',
    newsBoard: 'Quadro de Notícias',
    noContentAvailable: 'Nenhum conteúdo disponível',
    viewEinDashboard: 'Ver painel EIN',
    enterComments: 'Insira seus comentários',
    maxAllowedComment: 'São permitidos no máximo %{maxCount} caracteres',
    switchingBackNote:
      'Voltando para a versão clássica do Enlighten Manager? Ajude-nos a melhorar a nova versão, compartilhando seu motivo para voltar',
    switchBackTitle: 'Mudar para o modo de exibição clássico por tempo limitado',
    new: 'Novo',
    view: 'Visualizar',
    gridProfileToken: 'Token de mudança de perfil de rede',
    ProfileTokenText: 'Token de mudança de perfil',
    validText: 'Este token é válido para o Envoy %{serialNumber} por um dia.',
    envoySerialNumber: 'Número de série do Envoy',
    authorizationNumber: 'Número de autorização',
    getToken: 'Obter Token',
    viewAll: 'Ver tudo',
    viewFullList: 'Ver lista completa',
    serviceRequests: 'Solicitações de serviço',
    inProgressRequests: 'Em andamento',
    totalCases: 'Total de casos',
    resolvedRequests: 'Resolvido',
    viewDetails: 'Ver detalhes'
  }
};

export default dashboard;
